import { css } from "lit";

export const statusBadgeStyles = css`
  .badge {
    --badge-letter-spacing: 1px;
    font-weight: var(--badge-font-weight, 700);
  }

  .badge.live {
    --badge-bg: var(--sds-color-red-500);
    --badge-color: var(--sds-color-red-100);
  }

  .badge.ended {
    --badge-bg: var(--sds-color-background-default-tertiary);
    --badge-color: var(--sds-color-text-default-secondary);
  }

  .badge.cancelled {
    --badge-bg: var(--sds-color-background-default-secondary);
    --badge-color: var(--sds-color-text-default-secondary);
  }

  .badge.scheduled {
    --badge-bg: var(--sds-color-background-default-secondary);
    --badge-color: var(--sds-color-text-default-secondary);
  }

  .badge.price {
    --badge-bg: var(--sds-color-background-default-secondary);
    --badge-color: var(--sds-color-text-default-secondary);
  }

  .badge.access {
    --badge-bg: var(--sds-color-background-success-default);
    --badge-color: var(--sds-color-text-success-on-success);
  }
  .badge.event {
    --badge-bg: var(--sds-color-background-tint-secondary);
    --badge-color: var(--sds-color-text-default-secondary);
    --badge-font-weight: 500;
    text-transform: uppercase;
  }
`;
